import { Card } from '@ui-kitten/components';
export default Card;
//# sourceMappingURL=Card.js.map